import { styled } from "@mui/material/styles";
import MuiDrawer from "@mui/material/Drawer";
import MuiAppBar from "@mui/material/AppBar";
import MuiListItemText from "@mui/material/ListItemText";
import { LAYOUT_HEADER_HEIGHT } from "../../constants/appConstants";

export const openedMixin = (theme) => ({
  width: drawerWidth,
  transition: theme.transitions.create("width", {
    easing: theme.transitions.easing.sharp,
    duration: theme.transitions.duration.enteringScreen,
  }),
  overflowX: "hidden",
  overflowY: "hidden",
  display: "flex",
  flexDirection: "column",
});

export const closedMixin = (theme) => ({
  transition: theme.transitions.create("width", {
    easing: theme.transitions.easing.sharp,
    duration: theme.transitions.duration.leavingScreen,
  }),
  overflowX: "hidden",
  overflowY: "hidden",
  display: "flex",
  flexDirection: "column",
  width: `calc(${theme.spacing(7)} + 1px)`,
  [theme.breakpoints.up("sm")]: {
    width: `calc(${theme.spacing(8)} + 1px)`,
  },
});

// DrawerHeader
export const DrawerHeader = styled("div")(() => ({
  display: "flex",
  alignItems: "center",
  justifyContent: "flex-end",
  height: LAYOUT_HEADER_HEIGHT,
  minHeight: LAYOUT_HEADER_HEIGHT,
  maxHeight: LAYOUT_HEADER_HEIGHT,
  boxSizing: "border-box",
  padding: "0 20px",
  flexShrink: 0,
}));

// Drawer
export const drawerWidth = 280;

export const Drawer = styled(MuiDrawer, {
  shouldForwardProp: (prop) => prop !== "open",
})(({ theme, open }) => ({
  width: drawerWidth,
  flexShrink: 0,
  boxSizing: "border-box",
  ...(open && {
    ...openedMixin(theme),
    "& .MuiDrawer-paper": {
      ...openedMixin(theme),
      whiteSpace: "normal",
    },
  }),
  ...(!open && {
    ...closedMixin(theme),
    "& .MuiDrawer-paper": {
      ...closedMixin(theme),
      whiteSpace: "nowrap",
    },
  }),
}));

export const ListTitle = styled("span")({
  justifyContent: "space-between",
});
export const StyledTitle = styled('h1')({
  fontSize: "1.2em",
  fontWeight: 300,
  textTransform: "capitalize",
  textAlign: "center",
  width: "100%"
});

export const StyledBold = styled('b')(({ theme }) => ({
  fontSize: "inherit",
  fontWeight: 600,
  color: theme.palette.primary.main
}));

export const ListItemText = styled(MuiListItemText)(({ theme }) => ({
  width: "100%",
  minWidth: 0,
  "& .MuiListItemText-primary, & .MuiListItemText-secondary": {
    fontSize: "0.95rem",
    fontWeight: 400,
    whiteSpace: "normal",
    overflowWrap: "anywhere",
    wordBreak: "break-word",
    lineHeight: 1.35,
  },
  "& .MuiListItemText-secondary": {
    color: "inherit",
  },
}));

// export const LogoutButton = styled("button") (() => ({
//   background: none,
//   border: none,
//   color:appColors.gray900,
//   cursor: pointer,
//   display: block,
//   padding: 8px,
//   text-align: center,
//   width: 100%,

//   &:hover {
//     background-color: #f5f5f5;
//   }
// }));

// export const DrawerButton = styled.button`
//   background: none;
//   border: none;
//   color: #333;
//   cursor: pointer;
//   display: block;
//   padding: 8px;
//   text-align: center;
//   width: 100%;

//   &:hover {
//     background-color: #f5f5f5;
//   }
// `;

// export const DrawerContent = styled.div`
//   background-color: #f5f5f5;
//   padding: 8px;
// `;
export const AppBar = styled(MuiAppBar, {
  shouldForwardProp: (prop) => prop !== "open",
})(({ theme, open }) => ({
  zIndex: theme.zIndex.drawer + 1,
  transition: theme.transitions.create(["width", "margin"], {
    easing: theme.transitions.easing.sharp,
    duration: theme.transitions.duration.leavingScreen,
  }),
  ...(open && {
    marginLeft: drawerWidth,
    width: `calc(100% - ${drawerWidth}px)`,
    transition: theme.transitions.create(["width", "margin"], {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.enteringScreen,
    }),
  }),
}));
